// .action-sheet elements render as bottom sheets on phones and as centred modals on
// desktop via the .action-sheet--desktop variant. Applied at load and on viewport change,
// never to a sheet that is open (avoids a mid-animation class flip).

export function initActionSheetDesktopSync(): void {
    if (!window.matchMedia) return;
    const mq = window.matchMedia('(min-width: 769px)');

    const sync = () => {
        const isDesktop = mq.matches;
        document.querySelectorAll<HTMLElement>('.action-sheet').forEach((sheet) => {
            if (sheet.classList.contains('is-open')) return;
            sheet.classList.toggle('action-sheet--desktop', isDesktop);
        });
    };

    if (document.readyState !== 'loading') sync();
    else document.addEventListener('DOMContentLoaded', sync);

    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', sync);
    else (mq as MediaQueryList & { addListener?: (cb: () => void) => void }).addListener?.(sync);
}
